import { Component, OnInit, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CheckboxComponent),
  multi: true
};

@Component({
  selector: 'lfwms-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.css'],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
/* Sample Usage
 <lfwms-checkbox  [(ngModel)]="cellDataMap['defaultStrategykey'].cVal">
                  {{ getCellTitle('myCheckboxLabel')  }}
              </lfwms-checkbox>
*/
export class CheckboxComponent implements OnInit {

  public isChecked: any = false;
  public checkboxDisabled: boolean;
  @Input()
  public mode: string;  /* 'Y:N' or '1:0' or 'true:false' */
  private trueValue: any;  /* Y / 1 /true */
  private falseValue: any; /* N/0/false */

  private onTouchedCallback: () => void = () => { };
  private onChangeCallback: (_: any) => void = () => { };


  constructor() { }

  ngOnInit() {
    // console.log('ngOnInit',this.mode)
    switch (this.mode) {
        case 'Y:N':
                  this.trueValue = 'Y';
                  this.falseValue = 'N';
                  break;
        case '1:0':
                  this.trueValue = '1';
                  this.falseValue = '0';
                  break;
        case 'true:false':
                  this.trueValue = true;
                  this.falseValue = false;
                  break;
        default:
                this.trueValue = 'Y';
                this.falseValue = 'N';
                break;
    }
  }



  writeValue(writeValue: any): void {
    // console.log('writeValue');
    if (writeValue) {
      this.isChecked = (writeValue === this.trueValue);
    }
  //  console.log(writeValue, this.isChecked);
  }
  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
     this.checkboxDisabled = isDisabled;
  }

  select() {
    if (this.checkboxDisabled) {
      return;
    }
    this.isChecked = true;
    this.onChangeCallback(this.trueValue);
  }

  unselect() {
    if (this.checkboxDisabled) {
      return;
    }
    this.isChecked = false;
    this.onChangeCallback(this.falseValue);
  }


}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/checkbox/checkbox.component.ts